import { RootStore } from '@/store/rootStore'
import { Module } from 'vuex'

export const UsersAccess: Module<any, RootStore> = {
  namespaced: true,
  state: {
    usersAccess: [],
    usersAccessPermissions: [],
    causeOfDisputeList: [],
    franceSectorList: [],
    userTokenExpiration: null
  },
  mutations: {
    setUsersAccess (state, param) {
      state.usersAccess = param
    },
    setUsersAccessPermissions (state, param) {
      state.usersAccessPermissions = param
    },
    setCauseOfDisputeList (state, param) {
      state.causeOfDisputeList = param
    },
    setFranceSectorList (state, param) {
      state.franceSectorList = param
    },
    setUserTokenExpiration (state, param) {
      state.userTokenExpiration = param
    }
  },
  actions: {
    setUsersAccess ({ commit }, param) {
      commit('setUsersAccess', param)
    },
    setUsersAccessPermissions ({ commit }, param) {
      commit('setUsersAccessPermissions', param)
    },
    setCauseOfDisputeList ({ commit }, param) {
      commit('setCauseOfDisputeList', param)
    },
    setFranceSectorList ({ commit }, param) {
      commit('setFranceSectorList', param)
    },
    setUserTokenExpiration ({ commit }, param) {
      commit('setUserTokenExpiration', param)
    }
  },
  getters: {
    UsersAccess (state) {
      return state.usersAccess
    },
    UsersAccessPermissions (state) {
      return state.usersAccessPermissions
    },
    CauseOfDisputeList (state) {
      return state.causeOfDisputeList
    },
    FranceSectorList (state) {
      return state.franceSectorList
    },
    UserTokenExpiration (state) {
      return state.userTokenExpiration
    }
  }
}
